import { ContainerInfo, ContainerReference } from './container.model';
import { ContainerType } from '../enums/container-type.enum';
import { TaskParentContainerType } from '../enums/deprecated-task.enum';
import { GearInfo } from './gear.model';
import { Origin } from './origin.model';
import { Parents } from './parents.model';

export type File = FileSubdocument & FileStandalone;

/**
 * Represents file properties as they existed as subdocuments within container records.
 */
interface FileSubdocument {
  _id: string // ID within storage provider
  classification: FileClassification
  copy_of?: CopyOfInfo
  created: string
  cvat?: CVATFileInfo
  deid_log_id?: string
  gear_info?: GearInfo
  hash: string
  info_exists?: boolean // removed in core-api
  info: FileInfo
  mimetype: string
  modality: string
  modified: string
  name: string
  origin: FileOrigin
  parent?: ContainerReference // UI-added field
  path: string
  provider_id: string
  replaced: string
  size: number
  tags: string[]
  type: FileType | string
  virus_scan?: { state: 'quarantined' | 'clean' | 'virus' }
  zip_member_count: number
}

/**
 * Represents properties added to files when migrated to a standalone collection.
 */
interface FileStandalone {
  deleted: string
  file_id: string // ID within Mongo
  parent_ref: {
    id: string
    type: ContainerType
  }
  parents: Parents
  restored_by?: FileOrigin
  restored_from?: number
  version: number
}

export interface FileVersion {
  created: string
  deleted: string
  file_id: string
  origin: FileOrigin
  restored_by?: FileOrigin
  restored_from?: number
  version: number
}

export interface FileKey {
  id: string
  file_id: string
  name: string
  type: ContainerType
  version: number
}

export interface FileOrigin extends Origin {
  method?: string
  name?: string
  via?: FileOrigin
}

export interface FileClassification {
  [prop: string]: string[]
}

export interface FileClassificationChange {
  modality?: string
  add?: FileClassification
  delete?: FileClassification
  replace?: FileClassification
}

export enum FileType {
  SourceCode = 'source code'
}

export interface FileInfo extends ContainerInfo {
  BIDS?: any // eslint-disable-line @typescript-eslint/no-explicit-any
}

export interface ArchiveMemberInfo {
  comment: string
  members: ArchiveMember[]
}

export interface ArchiveMember {
  comment: string
  path: string
  timestamp: string
  size: number
}

export interface FileMoveBody {
  container_reference?: {
    type: ContainerType
    id: string // container._id
  }
  name?: string // file.name
  run_gear_rules?: boolean
}

export interface FileTypes {
  [key: string]: string[]
}

export interface CopyOfInfo {
  file_id: string
  group_label?: string
  parents: Parents
  project_label?: string
  version: number
}

export interface TaskParentFileInfo {
  id: {
    file_id: string,
    version: number
  }
  name: string
  parent_type: TaskParentContainerType
}

export enum CVATSyncState {
  Synced = 'synced',
  NotSynced = 'not_synced',
  Error = 'error'
}
export interface CVATFileInfo {
  error_summary: string;
  errors: string[],
  job_id: number,
  task_id: number,
  sync_state: CVATSyncState
}
